<app-navbar title="Dodatki i Potrącenia">
	<div class="d-flex flex-row-reverse">
		<button (click)="addFiles('mobility_package')" class="btn btn-primary ms-2">
			<i class="fas fa-download"></i> Import pakiet mobilności
		</button>
		<button (click)="addFiles('flix')" class="btn btn-primary ms-2">
			<i class="fas fa-download"></i> Import Flix
		</button>
		<button (click)="addFiles('settlement')" class="btn btn-primary ms-2">
			<i class="fas fa-download"></i> Import Dodatki
		</button>

		<a routerLink="./add" class="btn btn-primary"> <i class="fas fa-plus"></i> Dodaj </a>
	</div>
</app-navbar>
<input type="file" #fileMobilityPackage class="d-none" (change)="uploadFile($event, 'mobility_package')" multiple />
<input type="file" #fileFlix class="d-none" (change)="uploadFile($event, 'flix')" multiple />
<input type="file" #fileSettlement class="d-none" (change)="uploadFile($event, 'settlement')" multiple />
<div class="row filters-row m-2">
	<div class="col-md-10">
		<input
			type="text"
			class="form-control w-100"
			(keyup)="refreshFilter()"
			[(ngModel)]="filterValue"
			placeholder="Filtrowanie (min. 3 znaki)"
		/>
	</div>
	<div class="col-md-2 text-center">
		<button class="me-4" mat-raised-button color="primary" (click)="filtersOpen()">
			<i class="fas fa-filter"></i>
		</button>
	</div>
</div>
<div class="card-body">
	<div class="form-inline">
		<label class="me-4">
			Suma wartości rozliczonych:
			{{ this.sumIsSettled.toFixed(2) }}</label
		>
		<label class="me-4"> Suma wartości nierozliczonych: {{ this.sumIsNotSettled.toFixed(2) }} </label>
		<label class="me-4"> Suma wartości: {{ this.sum.toFixed(2) }} </label>
	</div>
</div>

<app-settlement-bonus-list-filter
	userFilters="settlement"
	[drivers]="parameters.drivers"
	[users]="parameters.users"
	[settlementBonusNames]="parameters.settlementBonusNames"
	[settlementKinds]="parameters.settlementKinds"
	[driverKinds]="parameters.driverKinds"
	[confirm]="parameters.confirm"
	[workshop]="parameters.workshop"
	[vehicles]="parameters.vehicles"
	(selected)="filtersSelected($event)"
>
</app-settlement-bonus-list-filter>

<ng-container *ngIf="showTable">
	<mat-table
		[dataSource]="matData"
		matSort
		matSortActive="id"
		matSortDirection="asc"
		grouping="false"
		cdkDropList
		cdkDropListDisabled="true"
	>
		<ng-container matColumnDef="checkbox">
			<mat-header-cell *matHeaderCellDef>
				<mat-checkbox
					[indeterminate]="isAnyChecked()"
					[(ngModel)]="toggleAllChecked"
					color="primary"
				></mat-checkbox>
			</mat-header-cell>
			<mat-cell *matCellDef="let element; let i = index"
				><mat-checkbox
					color="primary"
					[(ngModel)]="element.checked"
					(click)="checkMultipleSelection($event, i)"
				></mat-checkbox
			></mat-cell>
		</ng-container>
		<ng-container matColumnDef="id">
			<mat-header-cell *matHeaderCellDef mat-sort-header> Id </mat-header-cell>
			<mat-cell *matCellDef="let element">{{ element.id }}</mat-cell>
		</ng-container>
		<ng-container matColumnDef="owner">
			<mat-header-cell *matHeaderCellDef mat-sort-header class="mat-cell-big"> Pracownik </mat-header-cell>
			<mat-cell *matCellDef="let element" class="mat-cell-big">{{ element.owner }}</mat-cell>
		</ng-container>
		<ng-container matColumnDef="name">
			<mat-header-cell *matHeaderCellDef mat-sort-header class="mat-cell-big">
				Dodatek/Potrącenie
			</mat-header-cell>
			<mat-cell *matCellDef="let element" class="mat-cell-big">{{ element.name }}</mat-cell>
		</ng-container>
		<ng-container matColumnDef="vehicle">
			<mat-header-cell *matHeaderCellDef mat-sort-header class="mat-cell-big"> Pojazd </mat-header-cell>
			<mat-cell *matCellDef="let element" class="mat-cell-big">{{ element.vehicle }}</mat-cell>
		</ng-container>
		<ng-container matColumnDef="value">
			<mat-header-cell *matHeaderCellDef mat-sort-header class="mat-cell-big"> Wartość </mat-header-cell>
			<mat-cell *matCellDef="let element" class="mat-cell-big">{{ element.value }}</mat-cell>
		</ng-container>
		<ng-container matColumnDef="isSettled">
			<mat-header-cell *matHeaderCellDef mat-sort-header> Rozliczone </mat-header-cell>
			<mat-cell *matCellDef="let element">{{ element.isSettled }}</mat-cell>
		</ng-container>
		<ng-container matColumnDef="comment">
			<mat-header-cell *matHeaderCellDef mat-sort-header class="mat-cell-big"> Komentarz </mat-header-cell>
			<mat-cell *matCellDef="let element" class="mat-cell-big">{{ element.comment }}</mat-cell>
		</ng-container>
		<ng-container matColumnDef="editAt">
			<mat-header-cell *matHeaderCellDef mat-sort-header class="mat-cell-big"> Ostania edycja </mat-header-cell>
			<mat-cell *matCellDef="let element" class="mat-cell-big">{{
				element.editAt + ' ' + element.editBy
			}}</mat-cell>
		</ng-container>
		<ng-container matColumnDef="createAt">
			<mat-header-cell *matHeaderCellDef mat-sort-header class="mat-cell-big"> Utworzono </mat-header-cell>
			<mat-cell *matCellDef="let element" class="mat-cell-big">{{
				element.createAt + ' ' + element.createBy
			}}</mat-cell>
		</ng-container>
		<ng-container matColumnDef="eventId">
			<mat-header-cell *matHeaderCellDef mat-sort-header class="mat-cell-big"> ID Wydarzenia </mat-header-cell>
			<mat-cell *matCellDef="let element" class="mat-cell-big">{{ element.eventId ?? '-' }}</mat-cell>
		</ng-container>
		<ng-container matColumnDef="confirmAt">
			<mat-header-cell *matHeaderCellDef mat-sort-header class="mat-cell-big"> Zatwierdzone </mat-header-cell>
			<mat-cell *matCellDef="let element" class="mat-cell-big">{{ element.confirm }}</mat-cell>
		</ng-container>
		<ng-container matColumnDef="workshop">
			<mat-header-cell *matHeaderCellDef mat-sort-header class="mat-cell-big"> Warsztat </mat-header-cell>
			<mat-cell *matCellDef="let element" class="mat-cell-big">{{ element.workshop }}</mat-cell>
		</ng-container>

		<ng-container matColumnDef="edit">
			<mat-header-cell *matHeaderCellDef></mat-header-cell>
			<mat-cell *matCellDef="let element">
				<a routerLink="/settlements/settlementBonus/{{ element.id }}" target="_blank">
					<button mat-raised-button color="primary">Edytuj</button>
				</a>
			</mat-cell>
		</ng-container>
		<mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
		<mat-row *matRowDef="let row; columns: displayedColumns" cdkDrag></mat-row>
	</mat-table>

	<div class="footer">
		<mat-paginator
			[pageSizeOptions]="[10, 20, 50]"
			[pageSize]="50"
			showFirstLastButtons
			aria-label="Select page of periodic elements"
		>
		</mat-paginator>
		<ng-select id="setAction" class="ms-4" name="setAction" placeholder="Wybierz opcje" [(ngModel)]="action.value">
			<ng-option *ngFor="let item of parameters.massAction" [value]="item">{{ item.name }}</ng-option>
		</ng-select>
		<ng-select
			id="setOwner"
			class="ms-4"
			name="setOwner"
			placeholder="Wybierz opcje"
			[(ngModel)]="action.user"
			*ngIf="action.value?.kind === 'setOwner'"
		>
			<ng-option *ngFor="let item of parameters.users" [value]="item.id">{{ item.name }}</ng-option>
		</ng-select>
		<button class="mx-4 my-auto" mat-raised-button color="primary" (click)="massAction(action.value)">
			<i class="fa-regular fa-pen-to-square"></i>
			Ustaw zaznaczonym
		</button>
	</div>

	<mat-paginator
		class="fixed-bottom"
		style="z-index: 0"
		[pageSizeOptions]="[20, 30, 50]"
		showFirstLastButtons
		aria-label="Select page of periodic elements"
	>
	</mat-paginator>
</ng-container>
